import React, { useState, useEffect } from 'react';
import { fetchBusinessInfo } from '../bridge';
import {
  IoCallOutline, IoGlobeOutline, IoNavigateOutline, IoLogoWhatsapp,
  IoChevronForwardOutline
} from 'react-icons/io5';
import '../styles/ContactInfo.css';

const ContactInfo = ({ userEmail }) => {
  const [businessAddress, setBusinessAddress] = useState('');
  const [website, setWebsite] = useState('');
  const [businessPhone, setBusinessPhone] = useState('');
  const [businessWhatsApp, setBusinessWhatsApp] = useState('');
  const [businessCountryCode, setBusinessCountryCode] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const previousBusinessInfo = await fetchBusinessInfo(userEmail);
        if (previousBusinessInfo) {
          setBusinessAddress(previousBusinessInfo.business_address || '');
          setWebsite(previousBusinessInfo.website || '');
          setBusinessPhone(previousBusinessInfo.business_phone || '');
          setBusinessWhatsApp(previousBusinessInfo.business_whatsapp || '');
          setBusinessCountryCode(previousBusinessInfo.country_code || '');
        }
      } catch (error) {
        console.error('Error fetching business info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userEmail]);

  const openGoogleMaps = (address) => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
  };

  const openWebsite = (site) => {
    window.open(`https://${site}`, '_blank');
  };

  const openCallsApp = (phone) => {
    window.open(`tel:${phone}`, '_blank');
  };

  const openWhatsApp = (countryCode, whatsapp) => {
    window.open(`https://wa.me/${countryCode}${whatsapp}`, '_blank');
  };

  if (loading) return null;

  const items = [
    businessAddress && {
      icon: <IoNavigateOutline size={20} color="#B8732A" />,
      iconBg: '#FFF4E6',
      text: businessAddress,
      onClick: () => openGoogleMaps(businessAddress),
    },
    website && {
      icon: <IoGlobeOutline size={20} color="#1D7AB5" />,
      iconBg: '#E8F4FD',
      text: website,
      onClick: () => openWebsite(website),
    },
    businessPhone && {
      icon: <IoCallOutline size={20} color="#6B3FA0" />,
      iconBg: '#F3EEF9',
      text: businessPhone,
      onClick: () => openCallsApp(businessPhone),
    },
    businessWhatsApp && !/^\+\d{1,2}$/.test(businessWhatsApp) && {
      icon: <IoLogoWhatsapp size={20} color="#1DA462" />,
      iconBg: '#E6F7EF',
      text: businessWhatsApp,
      onClick: () => openWhatsApp(businessCountryCode, businessWhatsApp),
    },
  ].filter(Boolean);

  if (items.length === 0) return null;

  return (
    <div className="contact-card">
      <div className="contact-card-header">
        <div className="contact-header-icon-wrap">
          <IoCallOutline size={20} color="#fff" />
        </div>
        <span className="contact-header-title">Contact</span>
      </div>
      <div className="contact-card-body">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <button className="contact-tile" onClick={item.onClick}>
              <div className="contact-tile-icon" style={{ backgroundColor: item.iconBg }}>
                {item.icon}
              </div>
              <span className="contact-tile-text">{item.text}</span>
              <IoChevronForwardOutline size={20} color="#CFC5BB" />
            </button>
            {index < items.length - 1 && <div className="contact-divider" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
